import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login.jsx';
import Guias from './pages/Guias.jsx';
import NuevaGuia from './pages/NuevaGuia.jsx';
import Pagina404 from './pages/404.js';
import Usuarios from './pages/Usuarios.jsx';
import NuevoUsuario from './pages/NuevoUsuario.jsx';
import DetalleUsuario from './pages/DetalleUsuario.jsx';
import Clientes from './pages/Clientes.jsx';
import NuevoCliente from './pages/NuevoCliente.jsx';
import Productos from './pages/Productos.jsx';
import NuevoProducto from './pages/NuevoProducto.jsx';
import Transportistas from './pages/Transportistas.jsx';
import NuevoTransportista from './pages/NuevoTransportista.jsx';
import Conductores from './pages/Conductores.jsx';
import NuevoConductor from './pages/NuevoConductor.jsx';
import Vehiculos from './pages/Vehiculos.jsx';
import NuevoVehiculo from './pages/NuevoVehiculo.jsx';
import DetalleCliente from './pages/DetalleCliente.jsx';
import DetalleProducto from './pages/DetalleProducto.jsx';
import DetalleTransportista from './pages/DetalleTransportista.jsx';
import DetalleConductor from './pages/DetalleConductor.jsx';
import DetalleVehiculo from './pages/DetalleVehiculo.jsx';
import Direcciones from './pages/Direcciones.jsx';
import NuevaDireccion from './pages/NuevaDireccion.jsx';
import DetalleDireccion from './pages/DetalleDireccion.jsx';
import Series from './pages/Series.jsx';
import NuevaSerie from './pages/NuevaSerie.jsx';
import NuevaGuiaTransportista from './pages/NuevaGuiaTransportista.jsx';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path='/' element={<Login/>}/>
        <Route path='/guias' element={<Guias/>}/>
        <Route path='/nueva-guia' element={<NuevaGuia/>}/>
        <Route path='/nueva-guia-transportista' element={<NuevaGuiaTransportista/>}/>
        <Route path='/usuarios' element={<Usuarios/>}/>
        <Route path='/nuevo-usuario' element={<NuevoUsuario/>}/>
        <Route path='/detalle-usuario/:codUsuarioActualizar' element={<DetalleUsuario/>}/>
        <Route path='/clientes-proveedores' element={<Clientes/>}/>
        <Route path='/nuevo-cliente' element={<NuevoCliente/>}/>
        <Route path='/detalle-cliente/:codClienteActualizar' element={<DetalleCliente/>}/>
        <Route path='/productos' element={<Productos/>}/>
        <Route path='/nuevo-producto' element={<NuevoProducto/>}/>
        <Route path='/detalle-producto/:codProductoActualizar' element={<DetalleProducto/>}/>
        <Route path='/transportistas' element={<Transportistas/>}/>
        <Route path='/nuevo-transportista' element={<NuevoTransportista/>}/>
        <Route path='/detalle-transportista/:codTransportistaActualizar' element={<DetalleTransportista/>}/>
        <Route path='/conductores' element={<Conductores/>}/>
        <Route path='/nuevo-conductor' element={<NuevoConductor/>}/>
        <Route path='/detalle-conductor/:codConductorActualizar' element={<DetalleConductor/>}/>
        <Route path='/vehiculos' element={<Vehiculos/>}/>
        <Route path='/nuevo-vehiculo' element={<NuevoVehiculo/>}/>
        <Route path='/detalle-vehiculo/:codVehiculoActualizar' element={<DetalleVehiculo/>}/>
        <Route path='/direcciones' element={<Direcciones/>}/>
        <Route path='/nueva-direccion' element={<NuevaDireccion/>}/>
        <Route path='/detalle-direccion/:codDireccionActualizar' element={<DetalleDireccion/>}/>
        <Route path='/series' element={<Series/>}/>
        <Route path='/nueva-serie' element={<NuevaSerie/>}/>

        <Route path='/404' element={<Pagina404/>}/>
        <Route path='/*' element={<Navigate to='404'/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
